import React, { useEffect } from 'react';
import LogCannon from '@ace-clublabs/log-cannon';
import { Route, Switch, useLocation } from 'react-router';
import { MembershipHome } from '../containers/MembershipHome';
import { ContactInfo } from '../containers/ContactInfo';
import { STATE_KEY, useGlobalState } from '../state/state';
import { IState } from '../state/model';
import { ChangeBenefitLevel } from '../containers/ChangeBenefitLevel';
import { MembersDetails } from '../containers/MembersDetails';
import { Pages } from '../utils/constants';
import { ManageMembership } from '../containers/ManageMembership';
import { AddRVMotorcycle } from '../containers/AddRVMotorcycle';
import { UpdateMembershipStatus } from '../containers/UpdateMembershipStatus';
import { AssociateForm } from '../containers/AssociateForm';
import { Confirmation } from '../containers/Confirmation';
import { RoleTypeSelection } from '../containers/RoleTypeSelection';
import { SorryPage } from '../containers/SorryPage';
import { MaintenancePage } from '../containers/MaintenancePage';
import { storeState } from '../state/storeState';

function usePageViews() {
  let location = useLocation();
  React.useEffect(() => {
    LogCannon.blast(`Navigate to ${location.pathname}`, {
      pathname: location.pathname,
      search: location.search,
    });

    window.scrollTo(0, 0);
  }, [location]);
}

const Router: React.FC = () => {
  usePageViews();

  const state: Partial<IState> = {
    memberDetails: useGlobalState('memberDetails')[0],
    formData: useGlobalState('formData')[0],
    paymentInfo: useGlobalState('paymentInfo')[0],
    confirmation: useGlobalState('confirmation')[0],
    priceCart: useGlobalState('priceCart')[0],
    prospectiveCosts: useGlobalState('prospectiveCosts')[0],
    additionalDiscounts: useGlobalState('additionalDiscounts')[0],
    content: useGlobalState('content')[0],
    tags: useGlobalState('tags')[0],
    isMobileApp: useGlobalState('isMobileApp')[0],
  };

  useEffect(() => {
    storeState(state);
  }, [state]);

  return (
    <Switch>
      <Route exact path={Pages.HomePage} component={MembershipHome} />
      <Route path={Pages.ContactInfoPage} component={ContactInfo} />
      <Route path={Pages.ChangeBenefitLevelPage} component={ChangeBenefitLevel} />
      <Route path={Pages.MembersDetailsPage} component={MembersDetails} />
      <Route path={Pages.ManageMembershipPage} component={ManageMembership} />
      <Route path={Pages.AddRVMotorcycle} component={AddRVMotorcycle} />
      <Route path={Pages.UpdateMembershipStatusPage} component={UpdateMembershipStatus} />
      <Route path={Pages.AssociateForm} component={AssociateForm} />
      <Route path={Pages.RoleTypeSelection} component={RoleTypeSelection} />
      <Route path={Pages.ConfirmationPage} component={Confirmation} />
      <Route path={Pages.MaintenancePage} component={MaintenancePage} />
      <Route exact path={Pages.PaymentError} component={() => <SorryPage errorType="payment" />} />
      <Route exact path={Pages.TimeoutError} component={() => <SorryPage errorType="timeout" />} />
      <Route path={Pages.SorryPage} component={SorryPage} />
    </Switch>
  );
};

export default Router;
